import { render } from "./AddSectionHead.vue?vue&type=template&id=6863261a"
import script from "./AddSectionHead.vue?vue&type=script&lang=js"
export * from "./AddSectionHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__